/**
 * Picks the payment method types the Stripe Elements group and the PaymentIntent should carry
 * for this payment attempt: only the method the shopper selected, when it is one of the offered types.
 *
 * Top-level options Stripe applies at confirmation must be valid for every type on the intent.
 * Ticking the Payment Element "save" checkbox adds a top-level setup_future_usage, which e.g.
 * pay_by_bank does not accept — so a card payment on an intent that merely lists pay_by_bank fails
 * ("Received unknown parameter: pay_by_bank[setup_future_usage]"). A single-type intent avoids that
 * for any method added to the dashboard later.
 *
 * Wallet selections (apple_pay, google_pay) are never among the offered types — Stripe charges
 * them as card — so they keep the full list, as does an unknown selection.
 */
export const resolveIntentPaymentMethodTypes = ({
  offeredTypes,
  selectedType,
}: {
  offeredTypes: string[];
  selectedType: string | null;
}): string[] => {
  const isSelectedTypeOffered = selectedType !== null && offeredTypes.includes(selectedType);
  return isSelectedTypeOffered ? [selectedType] : offeredTypes;
};
